import React, { useState } from 'react';
import './Navbar.css'; // Include CSS file for styling

import { Link, useLocation } from 'react-router-dom';

const DriverNavbar = () => {
  const location = useLocation(); // Get the current location
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to toggle menu

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">
          <img src="/Logo4.png" alt="Logo" />
          
        </Link>
      </div>
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-controls="navbar"
      >
        {isMenuOpen ? (
          <span className="cross">✖</span>
        ) : (
          <>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </>
        )}
      </button>
      
    </header>
  );
};

export default DriverNavbar;
